import { MapperBase } from '../../../utilities/mapper-base';
import { DocViewerContextDoc } from '@models/ui/doc-viewer-context-doc.model';
import { LexbeDoc } from '@models/doc.model';
import { EmailTypeToDisplayTypeMap } from '../maps/email-type-to-display-type.map';

export class LexbeDocToDocViewerContextDocMapper extends MapperBase<LexbeDoc, DocViewerContextDoc> {
    map(source: LexbeDoc): DocViewerContextDoc {
        const dest = new DocViewerContextDoc();
        dest.docId = source.docId;
        dest.docTitle = source.docTitle;
        dest.emailTypeId = source.emailType?.value;
        dest.hasChildren = false;
        dest.displayType= EmailTypeToDisplayTypeMap.get(source.emailType?.value);
        return dest;
    }

}
